// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EaRu1WQFkNs3Vj6_vCF_ {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 8px;
  border-radius: 8px;
}

.UW0IcCA3eXLghtDTnmuM {
  overflow-y: auto;
  height: calc(100% - 50px);
}

.RXIvbzJpGovFHWlASyM6 {
  height: 82%;
}

.AcUCOnO06GIDyzQ0llsK {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.SUCQI8iKOxLi0fCoLR2J {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.WCWojUHcVdSz6ChWEx6t {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 16px 0 8px 0;
  align-items: center;
}

.iimA0bC8_FU8qlvoBECA {
  width: 40%;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.tzDpzxh1bXInWC56WRCw {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.LGjMK0uwze5X_s41AvHr {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
}

.OiuNvtQJMHZnvQT9gybl {
  color: black;
  font-family: "Chakra Petch";
  font-size: 18px;
  font-weight: 500;
}

.elfkzqnxx8rAinbNcVZ1 {
  color: #62C370;
  font-family: "Chakra Petch";
  font-size: 18px;
  font-weight: 500;
  text-transform: uppercase;
}

.fTEYBk27HrnCgVPg7UZ0 {
  display: flex;
  flex-direction: row;
  column-gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/screens/ProjectInterestAdministration/ProjectInterest.module.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,cAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAAJ","sourcesContent":["\r\n.idoAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 8px;\r\n    border-radius: 8px;\r\n}\r\n\r\n.idoTableContainer {\r\n    overflow-y: auto;\r\n    height: calc(100% - 50px);\r\n}\r\n\r\n.tableContainer {\r\n    height: 82%;\r\n}\r\n\r\n.idoTableFooter {\r\n    width: 100%;\r\n    height: 50px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.editIDOContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.filterRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    margin: 16px 0 8px 0;\r\n    align-items: center;\r\n}\r\n\r\n.filterContainer {\r\n    width: 40%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 8px;\r\n}\r\n\r\n.filterCheckboxRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-evenly;\r\n}\r\n\r\n.statisticsRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 16px;\r\n}\r\n\r\n.statisticsLabel {\r\n    color: black;\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n}\r\n\r\n.statisticsValue {\r\n    color: #62C370;\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.statisticsBox {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"idoAdminContainer": `EaRu1WQFkNs3Vj6_vCF_`,
	"idoTableContainer": `UW0IcCA3eXLghtDTnmuM`,
	"tableContainer": `RXIvbzJpGovFHWlASyM6`,
	"idoTableFooter": `AcUCOnO06GIDyzQ0llsK`,
	"editIDOContainer": `SUCQI8iKOxLi0fCoLR2J`,
	"filterRow": `WCWojUHcVdSz6ChWEx6t`,
	"filterContainer": `iimA0bC8_FU8qlvoBECA`,
	"filterCheckboxRow": `tzDpzxh1bXInWC56WRCw`,
	"statisticsRow": `LGjMK0uwze5X_s41AvHr`,
	"statisticsLabel": `OiuNvtQJMHZnvQT9gybl`,
	"statisticsValue": `elfkzqnxx8rAinbNcVZ1`,
	"statisticsBox": `fTEYBk27HrnCgVPg7UZ0`
};
export default ___CSS_LOADER_EXPORT___;
